import React, { useState } from "react";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import CosCaseNoteCard from "./CosCaseNoteCard";
import DeleteCaseNote from "../DeleteCaseNote";
import { LoginContext } from "helpers/LoginContext";
import { canDeleteCosCaseNote } from "helpers/RolesPermission";

const SubmittedCaseNotesList = ({
  caseNotesList,
  casNotesListLoading,
  cosParticipantsProfile,
  getCaseNoteDetailRequest,
  setOpenUpdateCaseNoteModal,
  setRefreshTable,
  refreshTableAfterDelete,
  DeleteModal = DeleteCaseNote,
  canDelete = canDeleteCosCaseNote,
  caseNoteApiModule = "cos",
}) => {
  const { isUserGracePeriodOver } = React.useContext(LoginContext);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedUUID, setSelectedUUID] = useState(null);

  const handleEdit = (note) => {
    setOpenUpdateCaseNoteModal(true);
    if (cosParticipantsProfile) {
      getCaseNoteDetailRequest({
        uuid: note?.uuid,
        pt_id: cosParticipantsProfile?.uuid,
      });
    }
  };

  const handleDelete = (note) => {
    setSelectedUUID(note?.uuid);
    setOpenDeleteModal(true);
  };

  if (casNotesListLoading) {
    return (
      <div className='flex justify-center items-center py-10'>
        <CircularLoader
          classes='flex justify-center items-center'
          classloader='loader-l'
        />
      </div>
    );
  }

  if (!caseNotesList || caseNotesList.length === 0) {
    return (
      <div className='py-8 px-3 text-center'>
        <h3 className='text-base font-semibold text-gray-900'>No case notes yet</h3>
        <p className='mt-1 text-xs text-gray-600'>
          Use the form above to create your first case note for this funding
          period.
        </p>
      </div>
    );
  }

  return (
    <>
      <ul className='space-y-2 px-3 py-2'>
        {caseNotesList.map((note) => (
          <li key={note.uuid}>
            <CosCaseNoteCard
              note={note}
              ptUuid={cosParticipantsProfile?.uuid}
              caseNoteApiModule={caseNoteApiModule}
              onEdit={handleEdit}
              onDelete={handleDelete}
              isUserGracePeriodOver={isUserGracePeriodOver}
              canDelete={canDelete}
            />
          </li>
        ))}
      </ul>

      {openDeleteModal && (
        <DeleteModal
          selectedUUID={selectedUUID}
          closeModal={() => setOpenDeleteModal(false)}
          openDeleteModal={openDeleteModal}
          setRefreshTable={setRefreshTable}
          refreshTableAfterDelete={refreshTableAfterDelete}
          isUserGracePeriodOver={isUserGracePeriodOver}
        />
      )}
    </>
  );
};

export default SubmittedCaseNotesList;
